<template>
  <div>
    <div>
      <span class="secondhead-text">Your Progress</span>
    </div>
    <ProgressBar v-for="(progress_item, idx) in progress" :key="idx" :progress_item="progress_item"
      :loading="is_progress_loading" :data-cy="`content-ProgressBar-${idx}`" />
  </div>
</template>

<script>
import ProgressBar from "./ProgressBar.vue";
import { mapGetters } from "vuex";

export default {
  name: "YourProgress",
  components: {
    ProgressBar,
  },
  data() {
    return {
      progress: [
        {
          name: "Plan (PPDP)",
          field: 'ppdp_meetings',
          plan_comlpete: false,
          meeting_approved: false,
          progress: {
            complete: 0,
            total: 1
          }
        },
        {
          name: "Distinct Experiences",
          field: 'total_approved_distinct_Experiences',
          progress: {
            complete: 0,
            total: 4
          }
        },
        {
          name: "Debriefings",
          field: "debriefings",
          progress: {
            complete: 0,
            total: 2
          }
        },
        {
          name: "Fieldwork Hours",
          field: "total_approved_hours",
          progress: {
            complete: 0,
            total: 18
          }
        }
      ]
    }
  },
  watch: {
    is_progress_loading: {
      handler() {
        console.log("PROGRESS LOADING::", this.is_progress_loading)
        if (!this.is_progress_loading) {
          Object.entries(this.progress_status).forEach((item) => {
            const pidx = this.progress.findIndex((pitem) => pitem.field === item[0])
            this.progress[pidx].progress.complete = item[1]
          })
        }
      }
    }
  },
  mounted() {
    this.progress_items.forEach((item) => {
      const pidx = this.progress.findIndex((pitem) => pitem.name === item.name)
      this.progress[pidx].progress.total = item.progress.total
    })
  },
  computed: {
    ...mapGetters(["getAcadLevel", "getStudentLevels", "progress_items", "is_progress_loading", "progress_status"]),
  },
};
</script>

<style scoped></style>
